"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendCode = sendCode;
var _view = require("../../types/view");
var _phoneAuth = require("../../types/phoneAuth");
var _requestStatus = require("../../types/requestStatus");
var _action_types = require("../../constants/action_types");
var _view2 = require("../view");
var _sendCode = require("../../api/sendCode");
var _authErrorType = require("../../types/phoneAuth/authErrorType");
function sendCode() {
  return async (dispatch, getState, context) => {
    const {
      view: {
        active: activeView
      },
      phoneAuth: {
        phone
      }
    } = getState();
    dispatch({
      status: _requestStatus.ERequestStatus.Loading,
      type: _action_types.PHONE_AUTH_SEND_CODE_TYPE
    });

    // сбрасываем ошибки авторизации по телефонному коду
    dispatch({
      status: _phoneAuth.ERegisterOrAuthStatus.Initial,
      type: _action_types.PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE
    });
    const result = await (0, _sendCode.sendCode)(context, phone);
    if (result.status === _sendCode.ESendCodeStatus.Succeed) {
      dispatch({
        status: _requestStatus.ERequestStatus.Succeed,
        type: _action_types.PHONE_AUTH_SEND_CODE_TYPE,
        senderType: result.senderType,
        secondsToRetry: result.secondsToRetry,
        timeStamp: result.timeStamp
      });
      if (result.senderType === _sendCode.ESenderType.Sms && activeView !== _view.EActiveView.PhoneAuthValidateSms) {
        dispatch((0, _view2.changeView)(_view.EActiveView.PhoneAuthValidateSms));
      }
      if (result.senderType === _sendCode.ESenderType.Call && activeView !== _view.EActiveView.PhoneAuthValidateCall) {
        dispatch((0, _view2.changeView)(_view.EActiveView.PhoneAuthValidateCall));
      }
    } else if (result.status === _sendCode.ESendCodeStatus.Failed && result.errors.length > 0 && result.errors[0].code === _authErrorType.EAuthErrorType.CodeInputLimitReached) {
      dispatch((0, _view2.changeView)(_view.EActiveView.PhoneAuth, {
        notice: {
          title: 'Попробуйте через час',
          text: 'Вы много раз ввели неверный код, и нам пришлось заблокировать аккаунт'
        }
      }));
      dispatch({
        status: _requestStatus.ERequestStatus.Failed,
        type: _action_types.PHONE_AUTH_SEND_CODE_TYPE,
        error: result.errors[0].code
      });
      return;
    } else if (result.status === _sendCode.ESendCodeStatus.Failed && result.errors.length > 0 && result.errors[0].code === _authErrorType.EAuthErrorType.TemporaryBlock) {
      dispatch((0, _view2.changeView)(_view.EActiveView.PhoneAuth, {
        notice: {
          title: 'Подождите 15 минут',
          text: 'Вы часто запрашивали коды — иногда так ведут себя роботы. Если вы живой человек, убедитесь, что номер ваш, и попробуйте чуть позже'
        }
      }));
      dispatch({
        status: _requestStatus.ERequestStatus.Failed,
        type: _action_types.PHONE_AUTH_SEND_CODE_TYPE,
        error: result.errors[0].code
      });
      return;
    } else if (result.status === _sendCode.ESendCodeStatus.Failed && result.errors.length > 0 && result.errors[0].code === _authErrorType.EAuthErrorType.PermanentBlock) {
      dispatch((0, _view2.changeView)(_view.EActiveView.PhoneAuth, {
        notice: {
          title: 'Аккаунт заблокирован',
          text: 'Напишите в поддержку'
        }
      }));
      dispatch({
        status: _requestStatus.ERequestStatus.Failed,
        type: _action_types.PHONE_AUTH_SEND_CODE_TYPE,
        error: result.errors[0].code
      });
      return;
    } else {
      dispatch((0, _view2.changeView)(_view.EActiveView.PhoneAuth));
      dispatch({
        status: _requestStatus.ERequestStatus.Failed,
        type: _action_types.PHONE_AUTH_SEND_CODE_TYPE,
        error: result.message
      });
    }
  };
}